import { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useTakeMealtModel } from "../takeMealtModel"
import { ITakeMealtDetial } from "../takeMealtTypes";
import { momentFormat } from "@/utils/utils";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, userLoadData,
        loadData, setSelectedRowKeys,
    } = useTakeMealtModel();

    const columns: ColumnsType<ITakeMealtDetial> = [
        {
            title: '序号',
            width: 65,
            render: (text, record, index) => `${index + 1}`,
            fixed: "left",
            align: "center"
        }, {
            title: '预定人',
            width: 120,
            dataIndex: 'user',
            render: text => text ? text.name : text
        }, {
            title: '联系电话',
            width: 120,
            dataIndex: 'user',
            render: text => text ? text.phone : text
        }, {
            title: '预定时间',
            width: 160,
            dataIndex: 'createTime',
            render: text => text ? momentFormat(text) : text
        }, {
            title: '预定菜品',
            width: 160,
            dataIndex: 'details',
            render: details => details ? details?.map((item: { food: { name: any; }; }) => item.food?.name ?? "").join() : details
        }, {
            title: '预计取餐时间',
            width: 160,
            dataIndex: 'appointTime',
        }
    ];


    useEffect(() => {
        loadData()
        userLoadData()
    }, [])

    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id as string]);
        }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
